import React from "react";

interface IRubIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const RubIcon: React.FC<IRubIconProps> = ({ sizeX = 25, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z"
                stroke="#D0BDF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M8.5 11.3333H13.8333C14.5406 11.3333 15.2189 11.0524 15.719 10.5523C16.219 10.0522 16.5 9.37391 16.5 8.66667C16.5 7.95942 16.219 7.28115 15.719 6.78105C15.2189 6.28095 14.5406 6 13.8333 6H10.5V18M8.5 14H13.8333"
                stroke="#D0BDF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
